var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imc_load" },
    [
      _vm.loaded_files.length > 0
        ? _c("div", { attrs: { id: "files_added_imc" } }, [
            _c(
              "ul",
              _vm._l(_vm.loaded_files, function (file) {
                return _c("li", { staticClass: "file" }, [
                  _c("input", {
                    attrs: { type: "hidden", name: "jform[files][]" },
                    domProps: { value: file.id },
                  }),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("file-pond", {
        ref: "pond",
        attrs: {
          name: "imcfileloader",
          "allow-multiple": "true",
          server: _vm.getConfig(),
          "label-idle": "Додати файл (натисніть або перетяніть файл)",
          files: _vm.myFiles,
        },
        on: { init: _vm.handleFilePondInit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }